/**
 * Cache identity for Harnesses.
 *
 * Mirrors `llm-profiles/queryKeys.ts`: typed factories rather than inline
 * arrays so the query and every invalidation that follows a mutation cannot
 * drift apart (constitution §2.6).
 */
export const harnessKeys = {
  all: () => ['harnesses'] as const,
  list: () => ['harnesses', 'list'] as const,
  detail: (id: string) => ['harnesses', 'detail', id] as const,
};

/** The deployment's harness types: one list, read-only. */
export const harnessTypeKeys = {
  list: () => ['harness-types', 'list'] as const,
};
